// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","title":"footer_title__NO+Fr"};